import { Modal } from 'react-overlays';
import clsx from 'clsx';
import React from 'react';
import styles from '../../styles.module.css';

export const CyDModal = ({
  onClose,
  children,
  showModal,
  setShowModal,
  canScroll,
}) => {
  const renderBackdrop = (props) => (
    <div className={styles.customBackDrop} {...props} />
  );
  return (
    <Modal
      show={showModal}
      onHide={() => {
        setShowModal(false);
        if (onClose) {
          onClose();
        }
      }}
      className={''}
      renderBackdrop={renderBackdrop}
      onEscapeKeyDown={() => {
        setShowModal(false);
      }}
      onBackdropClick={() => {
        setShowModal(false);
      }}
    >
      <div className='z-50 fixed inset-0 flex justify-center items-center'>
        <div
          className={clsx('flex justify-center items-center relative w-full', {
            'overflow-none': canScroll !== undefined && !canScroll,
            'overflow-y-scroll': canScroll === undefined || canScroll,
          })}
        >
          <div className='flex justify-center items-center w-[90%] sm:w-auto'>
            {children}
          </div>
        </div>
      </div>
    </Modal>
  );
};
